import PropTypes from "prop-types";
// @mui
import { Popover } from "@mui/material";
import { menuItemClasses } from "@mui/material/MenuItem";
// components
import { getPosition } from "./utils";
import { StyledArrow } from "./styles";

// ----------------------------------------------------------------------

export default function XPopover({
                                     open,
                                     children,
                                     arrow = "top-right",
                                     hiddenArrow,
                                     sx,
                                     onClose,
                                     onBackdropClick,
                                     ...other
                                 }) {
    const { style, anchorOrigin, transformOrigin } = getPosition(arrow);

    return (
        <Popover
            { ...other }

            open={ Boolean(open) }

            anchorEl={ open }
            anchorOrigin={ anchorOrigin }
            transformOrigin={ transformOrigin }

            slotProps={ {
                paper: {
                    sx: {
                        width: "auto",
                        overflow: "inherit",
                        ...style,
                        [ `& .${ menuItemClasses.root }` ]: {
                            "& svg": {
                                mr: 2,
                                flexShrink: 0
                            }
                        },
                        ...sx
                    }
                },
                backdrop: {
                    onClick: onBackdropClick || onClose
                }
            } }

            onClose={ onClose }

            PaperProps={ {
                sx: {
                    width: "auto",
                    overflow: "inherit",
                    ...style,
                    [ `& .${ menuItemClasses.root }` ]: {
                        "& svg": {
                            mr: 2,
                            flexShrink: 0
                        }
                    },
                    ...sx
                }
            } }

            BackdropProps={ {
                onClick: onBackdropClick || onClose
            } }
        >
            { !hiddenArrow && <StyledArrow arrow={ arrow } /> }

            { children }
        </Popover>
    );
}

XPopover.propTypes = {
    sx: PropTypes.object,
    open: PropTypes.object,
    children: PropTypes.node,
    hiddenArrow: PropTypes.bool,
    disabledArrow: PropTypes.bool,
    onClose: PropTypes.func,
    onBackdropClick: PropTypes.func,
    arrow: PropTypes.oneOf([
        "top-left",
        "top-center",
        "top-right",
        "bottom-left",
        "bottom-center",
        "bottom-right",
        "left-top",
        "left-center",
        "left-bottom",
        "right-top",
        "right-center",
        "right-bottom"
    ])
};
